export const timing = (mark: string) => {
  performance.mark(mark + ' start')
  return () => {
    performance.mark(mark + ' end')
    performance.measure(mark, mark + ' start', mark + ' end')
    performance.clearMarks(mark + ' start')
    performance.clearMarks(mark + ' end')
  }
}
